import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { FormInput, SelectInput } from '../../molecules';
import { TextBody } from '../../atoms';
export function FundInput({ onChange, valueId, values }) {
    // Vars
    const value = useMemo(() => {
        var _a;
        return (_a = values.find(_fund => _fund.code === valueId)) !== null && _a !== void 0 ? _a : null;
    }, [valueId, values]);
    // Handlers
    const handleChange = useCallback((code) => {
        const newValue = values.find(_fund => _fund.code === code);
        if (newValue) {
            onChange(newValue);
        }
    }, [onChange, values]);
    // Render
    return (_jsx(FormInput, { label: "Select the fund you\u2019re interested in", onChangeValue: handleChange, onChangePropName: "onChange", children: ({ onChange }) => (_jsx(SelectInput, { value: value, values: values, placeholder: "Select fund", onChange: _fund => { var _a; return onChange === null || onChange === void 0 ? void 0 : onChange((_a = _fund === null || _fund === void 0 ? void 0 : _fund.code) !== null && _a !== void 0 ? _a : undefined); }, getItemId: _fund => { var _a; return (_a = _fund === null || _fund === void 0 ? void 0 : _fund.code) !== null && _a !== void 0 ? _a : ''; }, getItemValue: _fund => { var _a; return (_a = _fund === null || _fund === void 0 ? void 0 : _fund.code) !== null && _a !== void 0 ? _a : ''; }, getSelectedItemTemplate: item => _jsx(TextBody, { em: true, children: item === null || item === void 0 ? void 0 : item.name }), getItemTemplate: item => _jsx(TextBody, { em: true, children: item === null || item === void 0 ? void 0 : item.name }) })) }));
}
